module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kevin Leman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Dr. Kevin Leman is an internationally known Christian psychologist, speaker, and "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author of fifty books, including "), _c('I', [_vm._v("Have a New Kid by Friday")]), _vm._v(", "), _c('I', [_vm._v("The Birth Order Book")]), _vm._v(", and "), _c('I', [_vm._v("Making Your Children Mind without Losing Yours")]), _vm._v(". A master communicator, Dr. Leman is a frequent guest on hundreds of radio and TV shows such as "), _c('I', [_vm._v("The View")]), _vm._v(", "), _c('I', [_vm._v("Oprah")]), _vm._v(", "), _c('I', [_vm._v("Today")]), _vm._v(", "), _c('I', [_vm._v("Fox & Friends")]), _vm._v(", and"), _c('I', [_vm._v(" Focus on the Famil")]), _vm._v("y. He and his wife, Sande, live in Tucson, Arizona. They are the parents of five children and two grandchildren.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nzrFOU/tc-custom/9781418514020.jpg?1728155742957",
      "alt": "This image is the cover for the book What a Difference a Daddy Makes"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("What a Difference a Daddy Makes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Study after study shows that fathers set up their daughters for success. Involved fathers-whether or not they live in the same house as their daughters-boost their daughters' academic achievement, promote their emotional health, increase their compassion for others, and even bolster the status of women. ")]), _c('p', [_c('i', [_vm._v("In What a Difference a Daddy Makes")]), _vm._v(", renowned psychologist and bestselling author Dr. Kevin Leman seamlessly weaves the latest research on fathering with funny, moving stories about his own parenting experiences. He gives practical ideas and inspiration for fathers and provides specific direction for helping daughters grow into loving, confident, caring adults.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0